/**
 * Created by workaxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev@workaxis.in
 * Date: 21/05/24
 * Time: 3:29 PM
 * Project: W-CRM
 */
import React from "react";

export default function WhatsappRawIcon({
                                            strokeWidth = 3,
                                            className = "w-1",
                                            stroke = "currentColor",
                                            fill = "none",
                                        }) {
    // Outline only (bubble + handset). The old glyph was a filled logo, so strokeWidth had no effect.
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            fill={fill}
            viewBox="0 0 24 24"
            stroke={stroke}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M3 21l1.65-3.8A9 9 0 1 1 7.4 20.1L3 21z" />
            <path d="M9 9v1a5 5 0 0 0 5 5h1" />
        </svg>
    );
}
